import React from "react";
import { Image } from "@project-stories/elements/Image/Image";

export function HeaderLogo({ settings, className = "" }) {
  return (
    <div className={`header-logo-container ${className}`}>
        {settings.globals.logo &&
            <a href="/" className="header-logo-image lg:pb-0">
                <Image imageUrl={settings.globals.logo} alt="Header logo" isLazy={true} width={settings.globals.logo_width} />
            </a>
        }

      <a href="/" className="header-logo"
         aria-label="Logo">
        {settings.globals.shop_title}
      </a>
    </div>
  );
}
